import { render, staticRenderFns } from "./RevenueManagerSetupPropertyList.vue?vue&type=template&id=6f86904c&scoped=true&"
import script from "./RevenueManagerSetupPropertyList.vue?vue&type=script&lang=js&"
export * from "./RevenueManagerSetupPropertyList.vue?vue&type=script&lang=js&"
import style0 from "./RevenueManagerSetupPropertyList.vue?vue&type=style&index=0&id=6f86904c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f86904c",
  null
  
)

export default component.exports